(function () {
  if (window.FilaContentSwitcher) {
    window.FilaContentSwitcher.init();
    return;
  }

  function getSwitchers() {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-content-switcher]"),
    );
  }

  function getTargets(group) {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-content-switch-group]"),
    ).filter(function (target) {
      return target.dataset.contentSwitchGroup === group;
    });
  }

  function getButtons(switcher) {
    return Array.prototype.slice.call(
      switcher.querySelectorAll("[data-content-switcher-button]"),
    );
  }

  function isElementScope(element) {
    return element.dataset.contentSwitchScope === "element";
  }

  function getSectionWrapper(element) {
    // 블록 단위로 연결한 대상은 섹션 전체가 아니라 그 요소만 숨긴다.
    if (isElementScope(element)) return element;
    return element.closest(".shopify-section") || element;
  }

  function setTargetVisibility(target, isActive) {
    var wrapper = getSectionWrapper(target);
    wrapper.setAttribute("data-content-switch-managed", "");
    wrapper.hidden = !isActive;
    wrapper.setAttribute("aria-hidden", isActive ? "false" : "true");

    if ("inert" in wrapper) {
      wrapper.inert = !isActive;
    }
  }

  function updateButtonControls(switcher, buttons, targets) {
    buttons.forEach(function (button) {
      var key = button.dataset.contentSwitchKey;
      var controls = targets
        .filter(function (target) {
          return target.dataset.contentSwitchKey === key;
        })
        .map(function (target, index) {
          var wrapper = getSectionWrapper(target);
          if (!wrapper.id) {
            wrapper.id =
              "ContentSwitchTarget-" +
              switcher.dataset.contentSwitcherSectionId +
              "-" +
              key +
              "-" +
              index;
          }
          return wrapper.id;
        });

      if (controls.length) {
        button.setAttribute("aria-controls", controls.join(" "));
      } else {
        button.removeAttribute("aria-controls");
      }
    });
  }

  function activate(switcher, requestedKey, focusButton) {
    var group = switcher.dataset.contentSwitcherGroup;
    var buttons = getButtons(switcher);
    if (!group || !buttons.length) return;

    var activeButton = buttons.find(function (button) {
      return button.dataset.contentSwitchKey === requestedKey;
    });
    if (!activeButton) activeButton = buttons[0];

    var activeKey = activeButton.dataset.contentSwitchKey;
    var targets = getTargets(group);

    targets.forEach(function (target) {
      setTargetVisibility(
        target,
        target.dataset.contentSwitchKey === activeKey,
      );
    });

    buttons.forEach(function (button) {
      var isActive = button === activeButton;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
      button.tabIndex = isActive ? 0 : -1;
    });

    updateButtonControls(switcher, buttons, targets);
    switcher.dataset.contentSwitcherActiveKey = activeKey;

    var initialStyle = document.getElementById(
      "ContentSwitcherInitial-" +
        switcher.dataset.contentSwitcherSectionId,
    );
    if (initialStyle) initialStyle.remove();

    if (focusButton) activeButton.focus();

    document.dispatchEvent(
      new CustomEvent("content-switcher:change", {
        detail: {
          group: group,
          key: activeKey,
          switcher: switcher,
        },
      }),
    );

    window.requestAnimationFrame(function () {
      window.dispatchEvent(new Event("resize"));
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    });
  }

  function getNextButton(buttons, currentIndex, key) {
    if (key === "Home") return buttons[0];
    if (key === "End") return buttons[buttons.length - 1];

    var direction = key === "ArrowLeft" ? -1 : 1;
    var nextIndex =
      (currentIndex + direction + buttons.length) % buttons.length;
    return buttons[nextIndex];
  }

  function isMobileViewport() {
    return window.innerWidth <= 749;
  }

  function getActiveIndex(switcher, buttons) {
    var activeKey = switcher.dataset.contentSwitcherActiveKey;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.contentSwitchKey === activeKey) return i;
    }
    return 0;
  }

  /*
    모바일 스와이프 전환. 버튼뿐 아니라 이 그룹에 연결된 콘텐츠 위에서 밀어도
    이전/다음 key로 넘어간다. 세로 스크롤을 막지 않도록 passive 리스너만 쓴다.
  */
  function bindSwipe(switcher) {
    if (switcher.dataset.contentSwitcherSwipe !== "true") return;

    var group = switcher.dataset.contentSwitcherGroup;
    if (!group) return;

    var threshold =
      parseInt(switcher.dataset.contentSwitcherSwipeThreshold, 10) || 40;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    function isInsideGroup(node) {
      if (!node || !node.closest) return false;
      if (switcher.contains(node)) return true;
      return !!node.closest('[data-content-switch-group="' + group + '"]');
    }

    document.addEventListener(
      "touchstart",
      function (event) {
        tracking = false;
        if (!isMobileViewport()) return;
        if (event.touches.length !== 1) return;
        if (!isInsideGroup(event.target)) return;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      },
      { passive: true },
    );

    document.addEventListener(
      "touchend",
      function (event) {
        if (!tracking) return;
        tracking = false;

        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;

        var deltaX = touch.clientX - startX;
        var deltaY = touch.clientY - startY;

        /* 세로 스크롤과 구분 */
        if (Math.abs(deltaX) < threshold) return;
        if (Math.abs(deltaX) < Math.abs(deltaY) * 1.5) return;

        var buttons = getButtons(switcher);
        if (buttons.length < 2) return;

        var currentIndex = getActiveIndex(switcher, buttons);
        var direction = deltaX < 0 ? 1 : -1;
        var nextIndex =
          (currentIndex + direction + buttons.length) % buttons.length;

        activate(switcher, buttons[nextIndex].dataset.contentSwitchKey, false);
      },
      { passive: true },
    );
  }

  function bindSwitcher(switcher) {
    if (switcher.dataset.contentSwitcherReady === "true") {
      activate(
        switcher,
        switcher.dataset.contentSwitcherActiveKey ||
          switcher.dataset.contentSwitcherDefaultKey,
        false,
      );
      return;
    }

    switcher.dataset.contentSwitcherReady = "true";

    switcher.addEventListener("click", function (event) {
      var button = event.target.closest("[data-content-switcher-button]");
      if (!button || !switcher.contains(button)) return;
      activate(switcher, button.dataset.contentSwitchKey, false);
    });

    switcher.addEventListener("keydown", function (event) {
      if (
        event.key !== "ArrowLeft" &&
        event.key !== "ArrowRight" &&
        event.key !== "Home" &&
        event.key !== "End"
      ) {
        return;
      }

      var button = event.target.closest("[data-content-switcher-button]");
      if (!button) return;

      var buttons = getButtons(switcher);
      var currentIndex = buttons.indexOf(button);
      if (currentIndex < 0) return;

      event.preventDefault();
      var nextButton = getNextButton(buttons, currentIndex, event.key);
      activate(switcher, nextButton.dataset.contentSwitchKey, true);
    });

    bindSwipe(switcher);

    activate(
      switcher,
      switcher.dataset.contentSwitcherDefaultKey,
      false,
    );
  }

  function init() {
    getSwitchers().forEach(bindSwitcher);
  }

  window.FilaContentSwitcher = {
    init: init,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

  document.addEventListener("shopify:section:select", function (event) {
    var targets = Array.prototype.slice.call(
      event.target.querySelectorAll("[data-content-switch-group]"),
    );
    // 블록 단위 대상만 있는 섹션은 어느 key를 켤지 알 수 없으므로 섹션 단위를 우선한다.
    var target =
      targets.filter(function (item) {
        return !isElementScope(item);
      })[0] || targets[0];
    if (!target) return;

    getSwitchers().forEach(function (switcher) {
      if (
        switcher.dataset.contentSwitcherGroup ===
        target.dataset.contentSwitchGroup
      ) {
        activate(switcher, target.dataset.contentSwitchKey, false);
      }
    });
  });

  document.addEventListener("shopify:block:select", function (event) {
    // 블록 단위로 연결한 블록을 고르면 그 블록이 보이는 key로 전환한다.
    var scopedTarget = event.target.matches("[data-content-switch-group]")
      ? event.target
      : event.target.querySelector("[data-content-switch-group]");

    if (scopedTarget && isElementScope(scopedTarget)) {
      getSwitchers().forEach(function (switcher) {
        if (
          switcher.dataset.contentSwitcherGroup ===
          scopedTarget.dataset.contentSwitchGroup
        ) {
          activate(switcher, scopedTarget.dataset.contentSwitchKey, false);
        }
      });
      return;
    }

    var button = event.target.matches("[data-content-switcher-button]")
      ? event.target
      : event.target.querySelector("[data-content-switcher-button]");
    var switcher = button
      ? button.closest("[data-content-switcher]")
      : null;
    if (!button || !switcher) return;
    activate(switcher, button.dataset.contentSwitchKey, false);
  });
})();
